export default __webpack_public_path__ + "static/media/dev-black.93b89d17.png";